import { createRouter, createWebHistory } from 'vue-router'
import homepage from '../components/AppBody.vue'
import guide from '../components/AppGuide.vue'
import module from '../components/AppModule.vue'
import purchase from '../components/AppPurchase.vue'
import resource from '../components/AppResource.vue'
import manager from '../components/AppManager.vue'
import guidefunction from '../components/GuideFunction.vue'
import guideinstall from '../components/GuideInstall.vue'
import guideuse from '../components/GuideUse.vue'
import guideerror from '../components/GuideError.vue'
import unit1 from '../components/ModuleUnit1.vue'
import unit2 from '../components/ModuleUnit2.vue'
import unit3 from '../components/ModuleUnit3.vue'
import unit4 from '../components/ModuleUnit4.vue'
import unit5 from '../components/ModuleUnit5.vue'
import unit6 from '../components/ModuleUnit6.vue'
import unit7 from '../components/ModuleUnit7.vue'
import road from '../components/ModuleRoad.vue'

const routes = [
    {path:'/',redirect:'/index',meta: {title: '唯奥衡卓'}},
    {path: '/index',name:'homepage',component: homepage,meta: {title: '唯奥衡卓'}}, 
    {path: '/guide',redirect:'/function',meta: {title: '指南|唯奥衡卓'},component: guide,
    children:[
        {path:'/function',name:'function',component:guidefunction,meta: {title: '功能 | 唯奥衡卓'},},
        {path:'/install',name:'install',component:guideinstall,meta: {title: '安装 | 唯奥衡卓'},},
        {path:'/use',name:'use',component:guideuse,meta: {title: '使用 | 唯奥衡卓'},},
        {path:'/error',name:'error',component:guideerror,meta: {title: '问题 | 唯奥衡卓'},}
    ]},
    {path: '/module',redirect:'/unit1',meta: {title: '模块|唯奥衡卓'},component: module,
    children:[
      {path:'/unit1',name:'unit1',component:unit1,meta: {title: '装配式单梁模块 | 唯奥衡卓'},},
      {path:'/unit2',name:'unit2',component:unit2,meta: {title: '装配式梁格模块 | 唯奥衡卓'},},
      {path:'/unit3',name:'unit3',component:unit3,meta: {title: '装配式桥墩模块 | 唯奥衡卓'},},
      {path:'/unit4',name:'unit4',component:unit4,meta: {title: '等高现浇箱梁模块 | 唯奥衡卓'},},
      {path:'/unit5',name:'unit5',component:unit5,meta: {title: '变高现浇箱梁模块 | 唯奥衡卓'},},
      {path:'/unit6',name:'unit6',component:unit6,meta: {title: '节段悬浇箱梁模块 | 唯奥衡卓'},},
      {path:'/unit7',name:'unit7',component:unit7,meta: {title: '裤衩箱梁模块 | 唯奥衡卓'},},
      {path:'/road',name:'road',component:road,meta: {title: '路线文件格式 | 唯奥衡卓'},},
    ]},
    {path: '/resource',name:'resource',meta: {title: '技术 | 唯奥衡卓'},component: resource,},
    {path: '/purchase',name:'purchase',meta: {title: '购买 | 唯奥衡卓'},component: purchase,},
    {path: '/manager',name:'manager',meta: {title: '管理员 | 唯奥衡卓'},component: manager,}
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title
    }
    next()
  })
export default router;